import { ApiClient } from "../ApiClient";

/**
 * Submit a support request
 * @param {Object} data - The support request details
 * @returns {Promise<Response>} The raw fetch response
 */
export const createSupportRequest = async (data) => {
  // ApiClient.post handles baseUrl, CSRF, and JSON stringification.
  // It returns the raw Response to maintain compatibility with calling components.
  return ApiClient.post("/account/contact-support", data);
};
